import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { TimeOffPolicy } from '@app/models/time-off-v3/time-off-policy.model';
import { TranslatableKey } from '@app/types/translatable.type';
import { SEMIMONTHLY, SemiMonthlyIntervals } from '@time-off-v3/meta/time-off-meta';

type Interval = (typeof SemiMonthlyIntervals)[number];
@Component({
    selector: 'app-semi-monthly-fields',
    templateUrl: './semi-monthly-fields.template.html',
    styleUrls: ['./semi-monthly-fields.style.scss'],
})
export class SemiMonthlyFieldsComponent implements OnDestroy {
    @Input() timeOffPolicy: TimeOffPolicy;
    @Input() containerClass = 'app-grid';
    @Input() fieldClass = 'columns-5 small-columns-12';
    @Input() firstDayOfPeriodLabel: TranslatableKey = 'time-off-v3.firstDayOfPeriod';

    @Output() requestPreviewParams: EventEmitter<string> = new EventEmitter();

    monthlyIntervals = SemiMonthlyIntervals;

    getIntervals(): Interval | void {
        // Check if value exist before performing operations on it.
        if (!this.timeOffPolicy.dayOfMonthOne) {
            return;
        }

        const interval = SemiMonthlyIntervals.find(({ firstDay, secondDay }) => {
            return this.timeOffPolicy.dayOfMonthOne === firstDay && this.timeOffPolicy.dayOfMonthTwo === secondDay;
        });

        return interval;
    }

    setIntervals(interval: Interval): void {
        this.timeOffPolicy.dayOfMonthOne = interval.firstDay;
        this.timeOffPolicy.dayOfMonthTwo = interval.secondDay;
    }

    previewDataChanged(): void {
        this.requestPreviewParams.emit(SEMIMONTHLY);
    }

    ngOnDestroy(): void {
        this.timeOffPolicy.resetDateValues(this.timeOffPolicy);
    }
}
